"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var iDom = require("@wk/incremental-dom");
require("./utils/attributesHooks");
var mergeDomChildren_1 = require("./utils/mergeDomChildren");
var attributes_1 = require("./utils/attributes");
exports.IDOM_EVENTS_KEY = '__idom-events__';
function processChildren(dom, children, context) {
    for (var i = 0; i < children.length; i++) {
        var child = children[i];
        if (Array.isArray(child)) {
            // for array we are rendering each of it
            processChildren(dom, child, context);
        }
        else if (typeof child === 'string') {
            // for all primitives we just rendering them as text
            iDom.text(child);
        }
        else if (typeof child === 'number') {
            // for all primitives we just rendering them as text
            iDom.text(child.toString());
        }
        else if (typeof child === 'function') {
            // for single we just calling it
            child(context);
        }
        else if (typeof child !== 'boolean' && child !== null && child !== undefined) {
            throw new Error('Unsuported type of child ' + child);
        }
        // do not render booleans, null and undefined
    }
}
function h(tag, attrs) {
    if (attrs === void 0) { attrs = {}; }
    var children = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        children[_i - 2] = arguments[_i];
    }
    if (typeof tag === 'string') {
        return tagNameH.apply(void 0, [tag, attrs].concat(children));
    }
    else if (typeof tag.tag === 'string') {
        return constructorH.apply(void 0, [tag, attrs].concat(children));
    }
    else {
        return tagFunctionH.apply(void 0, [tag, attrs].concat(children));
    }
}
exports.h = h;
function tagFunctionH(tag, attrs) {
    var children = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        children[_i - 2] = arguments[_i];
    }
    return function renderFn(context) {
        // tag can be undefined if nothing is returned
        if (tag) {
            var element = tag.apply(void 0, [attrs].concat(children));
            if (element) {
                return element(context);
            }
        }
    };
}
exports.tagFunctionH = tagFunctionH;
function constructorH(constructor, attrs) {
    var children = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        children[_i - 2] = arguments[_i];
    }
    var tag = constructor.tag;
    return function renderFn(context) {
        var customElements = context.parent.ownerDocument.defaultView.customElements;
        if (!customElements.get(tag)) {
            customElements.define(tag, constructor);
        }
        return tagNameH.apply(void 0, [tag, attrs].concat(children))(context);
    };
}
exports.constructorH = constructorH;
/**
 * JSX Pragma.
 */
function tagNameH(tagName, attrs) {
    var children = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        children[_i - 2] = arguments[_i];
    }
    return function renderFn(context) {
        var vnode = {
            context: context,
            element: renderFn,
            tag: tagName,
            attributes: attrs,
            children: children,
            skipChildren: false
        };
        if (context.handler && context.handler.beforeRender) {
            context.handler.beforeRender(vnode);
        }
        // preparing attributes
        var _a = attributes_1.parseAttributesObject(vnode.attributes), ref = _a.ref, childNodes = _a.childNodes, events = _a.events, innerHTML = _a.innerHTML, key = _a.key, attributes = _a.attributes, skipChildren = _a.skipChildren;
        vnode.skipChildren = vnode.skipChildren || skipChildren; // it might be skipped globally
        // render element
        var dom = attributes ? iDom.elementOpen.apply(iDom, [vnode.tag, key, null].concat(attributes)) :
            iDom.elementOpen(vnode.tag, key, null);
        // apply events handlers
        var oldEvents = dom[exports.IDOM_EVENTS_KEY] || {};
        Object.keys(events).forEach(function (name) {
            var _a = events[name], listener = _a.listener, capture = _a.capture;
            var oldEvent = oldEvents[name];
            // adding handler only for new events, this prevents to attach handlers more the once
            // if element is rerendered multiple times
            if (!oldEvent || oldEvent.capture !== capture || oldEvent.listener !== listener) {
                dom.addEventListener(name, listener, capture);
                // if there was an old event, then remove it
                if (oldEvent) {
                    dom.removeEventListener(name, oldEvent.listener, oldEvent.capture);
                }
            }
            // remove processed event from old events list
            delete oldEvents[name];
        });
        // if something is left in old events list
        Object.keys(oldEvents).forEach(function (name) {
            var oldEvent = oldEvents[name];
            dom.removeEventListener(name, oldEvent.listener, oldEvent.capture);
        });
        dom[exports.IDOM_EVENTS_KEY] = events;
        if (context.handler && context.handler.afterCreateNode) {
            context.handler.afterCreateNode(vnode, dom);
        }
        if (ref) {
            context.afterSet.push(function () {
                ref(dom);
            });
        }
        var skip = true;
        if (preserveInnerHtml(tagName, dom, innerHTML)) {
            var value_1 = dom.innerHTML;
            context.afterSet.push(function () {
                dom.innerHTML = value_1;
            });
        }
        else if (innerHTML) { // support for innerHTML
            context.afterSet.push(function () {
                if (dom.innerHTML !== innerHTML) {
                    dom.innerHTML = innerHTML;
                }
            });
        }
        else if (childNodes) {
            context.afterSet.push(function () {
                mergeDomChildren_1.mergeDomChildren(dom, childNodes);
            });
        }
        else {
            skip = vnode.skipChildren;
        }
        // processing children if not skip
        if (!skip) {
            var oldParent = context.parent;
            var oldLevel = context.level;
            context.parent = dom;
            context.level = oldLevel + 1;
            processChildren(dom, children, context);
            context.parent = oldParent;
            context.level = oldLevel;
        }
        else {
            iDom.skip();
        }
        iDom.elementClose(vnode.tag);
        if (context.handler && context.handler.afterRender) {
            context.handler.afterRender(vnode, dom);
        }
        return dom;
    };
}
exports.tagNameH = tagNameH;
function preserveInnerHtml(tag, element, explicitValue) {
    if (tag !== 'textarea' || explicitValue != null) {
        return false;
    }
    return element.innerHTML !== '';
}
/**
 * Rendering the content in provided parent.
 *
 * @param parent where to render
 * @param element what to render
 * @param handler
 * @param data
 * @return map of referenced children
 *      eg. for render(element, <a ref='myA'/>) will return {myA: HTMLAnchorElement}
 *      eg. for render(element, <div><a ref='myA'/><a ref='myA'/></div>) will return {myA: Array<HTMLAnchorElement>}
 */
function render(parent, element, handler, data) {
    if (handler === void 0) { handler = {}; }
    // postponed operations, we cant use setTimeout, render should be synchronous
    var context = {
        afterSet: [],
        parent: parent,
        handler: handler,
        level: 0,
        data: data
    };
    if (typeof element === 'function') {
        iDom.patch(parent, element, context);
    }
    else {
        var elements = function (ctx) {
            return element.map(function (e) { return e && e(ctx); });
        };
        iDom.patch(parent, elements, context);
    }
    if (context.afterSet.length > 0) {
        context.afterSet.forEach(function (x) { return x(); });
    }
}
exports.render = render;
/**
 * Factory of render function.
 */
function renderFactory(handler, data) {
    return function (parent, element, localData) {
        return render(parent, element, handler, localData || data);
    };
}
exports.renderFactory = renderFactory;
